import { render } from "./PsychicRegistrationModule.vue?vue&type=template&id=41be8d6c&scoped=true"
import script from "./PsychicRegistrationModule.vue?vue&type=script&lang=js"
export * from "./PsychicRegistrationModule.vue?vue&type=script&lang=js"

import "./PsychicRegistrationModule.vue?vue&type=style&index=0&id=41be8d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41be8d6c"]])

export default __exports__